export default {
  name: 'Nome',
  selectGroups: 'Seleção de grupos',
  group: 'Grupo'
}
